import { useEffect, useState } from "react";
import { api, API_BASE } from "@/lib/api";
import { rupiah, tanggalID } from "@/lib/format";
import { PageHeader } from "@/components/app/Layout";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Download, FileSpreadsheet, Search } from "lucide-react";

const Stat = ({ label, value, tone, testid }) => (
  <div data-testid={testid} className="card-flat p-5">
    <div className="text-[11px] uppercase tracking-widest text-slate-500">{label}</div>
    <div className={`mt-3 font-mono text-2xl tabular-nums ${tone}`}>{rupiah(value)}</div>
  </div>
);

const download = async (path, params, filename) => {
  const token = localStorage.getItem("khn_token");
  const url = new URL(`${API_BASE}${path}`);
  Object.entries(params).forEach(([k,v]) => v && url.searchParams.set(k, v));
  const res = await fetch(url, { headers: { Authorization: `Bearer ${token}` }});
  const blob = await res.blob();
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob); a.download = filename; a.click();
};

export default function LaporanSemua() {
  const [data, setData] = useState({ pemasukan: [], pengeluaran: [], total_pemasukan:0, total_pengeluaran:0, laba_bersih:0 });
  const [start, setStart] = useState(""); const [end, setEnd] = useState(""); const [q, setQ] = useState("");

  const load = async () => {
    const r = await api.get("/laporan/semua", { params: { start, end, q } });
    setData(r.data);
  };
  useEffect(()=>{ load(); }, []);

  return (
    <>
      <PageHeader title="Semua Laporan" subtitle="Ringkasan pemasukan, pengeluaran, dan laba bersih." actions={
        <div className="flex gap-2">
          <Button variant="outline" onClick={()=>download("/export/laporan-semua", {fmt:"pdf", start, end, q}, "laporan-semua.pdf")} className="rounded-sm" data-testid="dl-pdf">
            <Download size={14} className="mr-1"/> PDF
          </Button>
          <Button variant="outline" onClick={()=>download("/export/laporan-semua", {fmt:"xlsx", start, end, q}, "laporan-semua.xlsx")} className="rounded-sm" data-testid="dl-xlsx">
            <FileSpreadsheet size={14} className="mr-1"/> Excel
          </Button>
        </div>
      }/>
      <div className="p-8 space-y-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          <Stat testid="rpt-pemasukan" label="Total Pemasukan" value={data.total_pemasukan} tone="text-emerald-700"/>
          <Stat testid="rpt-pengeluaran" label="Total Pengeluaran" value={data.total_pengeluaran} tone="text-rose-700"/>
          <Stat testid="rpt-laba" label="Laba Bersih" value={data.laba_bersih} tone="text-slate-900"/>
        </div>
        <div className="card-flat p-5 grid grid-cols-1 md:grid-cols-4 gap-4">
          <div><Label>Dari Tanggal</Label><Input type="date" value={start} onChange={(e)=>setStart(e.target.value)}/></div>
          <div><Label>Sampai Tanggal</Label><Input type="date" value={end} onChange={(e)=>setEnd(e.target.value)}/></div>
          <div className="md:col-span-2"><Label>Pencarian</Label><Input placeholder="Cari nama, kategori..." value={q} onChange={(e)=>setQ(e.target.value)} data-testid="rpt-search"/></div>
          <div className="md:col-span-4"><Button onClick={load} className="brand-btn rounded-sm" data-testid="rpt-filter"><Search size={14} className="mr-1"/> Terapkan Filter</Button></div>
        </div>
        <div className="card-flat overflow-x-auto">
          <table className="w-full text-sm">
            <thead><tr className="bg-slate-50 border-b border-slate-200 text-left text-[12px] uppercase tracking-wide text-slate-500">
              <th className="p-3">Tanggal</th><th className="p-3">Tipe</th><th className="p-3">Nama</th><th className="p-3">Kategori</th><th className="p-3 text-right">Jumlah</th>
            </tr></thead>
            <tbody>
              {data.pemasukan.length===0 && data.pengeluaran.length===0 && <tr><td colSpan="5" className="text-center py-10 text-slate-400">Tidak ada data.</td></tr>}
              {data.pemasukan.map(x=>(
                <tr key={"i-"+x.id} className="border-b border-slate-100">
                  <td className="p-3 whitespace-nowrap">{tanggalID(x.tanggal)}</td>
                  <td className="p-3"><span className="text-[11px] px-2 py-0.5 bg-emerald-100 text-emerald-700 rounded-sm">Pemasukan</span></td>
                  <td className="p-3">{x.nama_barang}</td><td className="p-3">{x.kategori_nama||"-"}</td>
                  <td className="p-3 text-right font-mono text-emerald-700 font-semibold">+{rupiah(x.total)}</td>
                </tr>
              ))}
              {data.pengeluaran.map(x=>(
                <tr key={"o-"+x.id} className="border-b border-slate-100">
                  <td className="p-3 whitespace-nowrap">{tanggalID(x.tanggal)}</td>
                  <td className="p-3"><span className="text-[11px] px-2 py-0.5 bg-rose-100 text-rose-700 rounded-sm">Pengeluaran</span></td>
                  <td className="p-3">{x.nama_vendor}</td><td className="p-3">{x.kategori_nama||"-"}</td>
                  <td className="p-3 text-right font-mono text-rose-700 font-semibold">-{rupiah(x.nominal)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}
